import React from 'react'

const Error = () => {
    return (
        <div className=' grid place-items-center h-screen'>
            <h1 className='font-bold text-3xl text-white'>Application is shutdown.!!! Contact Developer</h1>
        </div>
    )
}

export default Error